<template>
    <modal-live ref="modal">
        <div class="modal-header">
            <h3 class="headline--modal">EULA</h3>
            <span class="modal__icon-close" @click="dismiss()">
                <svg>
                    <use :xlink:href="`${icons['close']}#icon`"></use>
                </svg>
            </span>
        </div>
        <div class="dialog">
            <h2 class="headline--welcome text-center">
                EULA and Privacy and Security Policy
            </h2>
            <div class="modal-scrollable">
                <p class="mb-0">
                    END USER LICENSE AGREEMENT<br />
                    IMPORTANT: BY USING THIS APP, YOU ARE AGREEING TO BE BOUND
                    BY THESE TERMS.<br />
                    Software License Agreement-Single Use License
                </p>
                <p class="mb-0">
                    PLEASE READ THIS SOFTWARE LICENSE AGREEMENT (“License”)
                    CAREFULLY BEFORE USING THIS APP OR DOWNLOADING ANY SOFTWARE
                    UPDATES ACCOMPANYING THIS LICENSE. BY DOWNLOADING OR USING
                    THIS APP, OR DOWNLOADING ANY SOFTWARE UPDATE, YOU ARE
                    AGREEING TO BE BOUND BY THE TERMS OF THIS LICENSE. IF YOU DO
                    NOT AGREE TO THE TERMS OF THIS LICENSE, THEN PLEASE DO NOT
                    USE, ACCESS OR INSTALL THIS APP OR DOWNLOAD ANY SOFTWARE
                    UPDATES.
                </p>
                <p class="mb-0">
                    The software, documentation, interfaces, content, fonts and
                    data for this App, as well as any software updates for this
                    App, are licensed, not sold, to you by TruckersReport LLC
                    (“TruckersReport”) doing business as Hammer for use only
                    under the terms of this License. TruckersReport retains
                    ownership of this App and reserves all rights not expressly
                    granted to you.
                </p>
                <p class="mb-0">
                    Subject to the terms and conditions of this License, you are
                    granted a limited, non-exclusive license to use this App.
                    Subject to the terms and conditions of this License, you are
                    granted a limited, non-exclusive license to download updates
                    that may be made available by TruckersReport.
                </p>
                <p class="mb-0">
                    You may not, and you agree not to, or enable others to, copy
                    (except as may be expressly permitted by this License),
                    decompile, reverse engineer, disassemble, attempt to derive
                    the source code, decrypt, modify, or create derivate works
                    of this App or any part thereof. You may not transfer, rent,
                    lease, lend, sell, redistribute, or sublicense this App. Any
                    attempt to do so is a violation of TruckerReport’s rights
                    and may subject you to prosecution and damages. You agree to
                    use this App in compliance with all applicable laws, whether
                    federal, state, municipal or any other legally enforceable
                    body.
                </p>
            </div>
            <div class="text-center pt-3 d-flex" style="gap: 15px">
                <Button
                    @click.native="dismiss()"
                    class="flex-fill"
                    :type="'outline'"
                >
                    I disagree
                </Button>
                <Button @click.native="dismiss()" class="flex-fill">
                    I agree
                </Button>
            </div>
        </div>
    </modal-live>
</template>

<script>
export default {
    data() {
        return {
            icons: window.here.icons,
        };
    },
    methods: {
        dismiss() {
            /* possibly store agreement? */
            this.$refs.modal.dismiss();
        },
    },
};
</script>

<style lang="scss">
.modal-header {
    border-bottom: 0;
    padding-top: 35px;
    padding-bottom: 16px;
    padding-left: 35px;
    padding-right: 35px;
}

.headline--modal {
    font-size: 20px;
    color: #958983;
    margin-bottom: 0;
}

.modal__icon-close {
    color: rgba(78, 58, 48, 0.2);
    cursor: pointer;
    transition: color 0.3s;
    position: absolute;
    top: 16px;
    right: 16px;

    svg {
        width: 40px;
        height: 40px;
    }

    &:hover {
        color: rgba(78, 58, 48, 0.6);
    }
}
</style>
